module.exports = __webpack_public_path__ + "c7a96bd62286e81a192494306cd4c7d5.png";